// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard.css - обновленные стили */

/* Основной контейнер */
.site-layout {
  transition: all 0.2s;
  background: #f0f2f5;
}

/* Шапка дашборда */
.dashboard-header {
  padding: 16px 24px;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 24px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

/* Стилизация карточек */
.dashboard-card {
  transition: all 0.3s ease;
  height: 100%;
}

.dashboard-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.09) !important;
  transform: translateY(-2px);
}

.dashboard-card .ant-card-head {
  background-color: #fafafa;
  border-bottom: 1px solid #f0f0f0;
}

.chart-container {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Улучшения для статистики */
.stats-container .ant-statistic {
  margin-bottom: 8px;
}

.stats-container .ant-statistic-title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}

.stats-container .ant-statistic-content {
  font-size: 20px;
  font-weight: 500;
}

/* Улучшения для Empty состояний */
.ant-empty {
  padding: 16px 0;
}

.ant-empty-description {
  color: rgba(0, 0, 0, 0.45);
}

/* Улучшенный селектор панелей */
.panel-selector {
  display: flex;
  align-items: center;
}

.panel-selector .ant-select {
  margin-left: 12px;
}

/* Адаптивность */
@media (max-width: 768px) {
  .dashboard-header {
    padding: 12px 16px;
  }
  
  .panel-selector {
    margin-top: 16px;
  }
  
  .chart-container {
    min-height: 160px;
  }
}

/* Дополнительные стили для иконок в статистике */
.stat-icon {
  font-size: 16px;
  margin-right: 8px;
}

/* Улучшенный стиль для карточек с информацией */
.info-card {
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
}

/* Анимация для загрузки */
.ant-spin {
  opacity: 0.8;
}

/* Улучшение для селектов */
.card-selectors .ant-select-selector {
  border-radius: 4px !important;
}

.card-selectors .ant-select:hover .ant-select-selector {
  border-color: #40a9ff;
}

/* Стили для улучшения счетчиков */
.ant-statistic-content-value {
  font-weight: 600;
}

/* Цветовые акценты для разных типов статистики */
.statistic-pushes .ant-statistic-content-value {
  color: #1890ff;
}

.statistic-regs .ant-statistic-content-value {
  color: #52c41a;
}

.statistic-deps .ant-statistic-content-value {
  color: #fa8c16;
}

.statistic-date .ant-statistic-content-value {
  color: #722ed1;
  font-size: 14px !important;
}
.ant-row.css-dev-only-do-not-override-240cud{
  display: flex;
  justify-content: center;
}

:where(.css-dev-only-do-not-override-36gkoj).ant-layout-content{
    display: grid;
    justify-content: space-around;
    justify-items: center;
}

.nickname{
  color:#f0f7fa !important
}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iDAAiD;AACjD;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;EACE;AACF","sourcesContent":["/* Dashboard.css - обновленные стили */\r\n\r\n/* Основной контейнер */\r\n.site-layout {\r\n  transition: all 0.2s;\r\n  background: #f0f2f5;\r\n}\r\n\r\n/* Шапка дашборда */\r\n.dashboard-header {\r\n  padding: 16px 24px;\r\n  background: #fff;\r\n  border-radius: 4px;\r\n  margin-bottom: 24px;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\r\n}\r\n\r\n/* Стилизация карточек */\r\n.dashboard-card {\r\n  transition: all 0.3s ease;\r\n  height: 100%;\r\n}\r\n\r\n.dashboard-card:hover {\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.09) !important;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.dashboard-card .ant-card-head {\r\n  background-color: #fafafa;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.chart-container {\r\n  min-height: 200px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* Улучшения для статистики */\r\n.stats-container .ant-statistic {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.stats-container .ant-statistic-title {\r\n  font-size: 12px;\r\n  color: rgba(0, 0, 0, 0.45);\r\n}\r\n\r\n.stats-container .ant-statistic-content {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Улучшения для Empty состояний */\r\n.ant-empty {\r\n  padding: 16px 0;\r\n}\r\n\r\n.ant-empty-description {\r\n  color: rgba(0, 0, 0, 0.45);\r\n}\r\n\r\n/* Улучшенный селектор панелей */\r\n.panel-selector {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.panel-selector .ant-select {\r\n  margin-left: 12px;\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n  .dashboard-header {\r\n    padding: 12px 16px;\r\n  }\r\n  \r\n  .panel-selector {\r\n    margin-top: 16px;\r\n  }\r\n  \r\n  .chart-container {\r\n    min-height: 160px;\r\n  }\r\n}\r\n\r\n/* Дополнительные стили для иконок в статистике */\r\n.stat-icon {\r\n  font-size: 16px;\r\n  margin-right: 8px;\r\n}\r\n\r\n/* Улучшенный стиль для карточек с информацией */\r\n.info-card {\r\n  background-color: #fff;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Анимация для загрузки */\r\n.ant-spin {\r\n  opacity: 0.8;\r\n}\r\n\r\n/* Улучшение для селектов */\r\n.card-selectors .ant-select-selector {\r\n  border-radius: 4px !important;\r\n}\r\n\r\n.card-selectors .ant-select:hover .ant-select-selector {\r\n  border-color: #40a9ff;\r\n}\r\n\r\n/* Стили для улучшения счетчиков */\r\n.ant-statistic-content-value {\r\n  font-weight: 600;\r\n}\r\n\r\n/* Цветовые акценты для разных типов статистики */\r\n.statistic-pushes .ant-statistic-content-value {\r\n  color: #1890ff;\r\n}\r\n\r\n.statistic-regs .ant-statistic-content-value {\r\n  color: #52c41a;\r\n}\r\n\r\n.statistic-deps .ant-statistic-content-value {\r\n  color: #fa8c16;\r\n}\r\n\r\n.statistic-date .ant-statistic-content-value {\r\n  color: #722ed1;\r\n  font-size: 14px !important;\r\n}\r\n.ant-row.css-dev-only-do-not-override-240cud{\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n:where(.css-dev-only-do-not-override-36gkoj).ant-layout-content{\r\n    display: grid;\r\n    justify-content: space-around;\r\n    justify-items: center;\r\n}\r\n\r\n.nickname{\r\n  color:#f0f7fa !important\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
